<div class="panel rs-no-padding rs-no-margin">
  <div>
    <div
      [class]="getWrapperClass(messageBox)"
      data-px-message
      aria-live="assertive"
      role="alertdialog"
      data-tms-event="popup-click-impression"
      attr.data-tms-popup-zone="{{ taggingName }}"
      data-tms-popup-name="fiber migration warning"
    >
      <div class="rs-msgbox-title" *ngIf="messageBox.title">
        {{ messageBox.title }}
      </div>
      <div class="rs-msgbox-content" data-cy="messageBoxDescription">
        <div [innerHTML]="messageBox.description"></div>
        <a
          href="{{ messageBox.btnUrl }}"
          class="rs-btn rs-btn-third"
          *ngIf="messageBox.btnLabel"
          data-tms-button-name="migrate to fiber"
          data-cy="messageBoxButton"
          >{{ messageBox.btnLabel }}
          <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
        ></a>
      </div>
      <div class="rs-msgbox-icon">
        <i [class]="getIconClass(messageBox)" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
